<template>
  <v-card>
    <v-card-text class="px-0 py-0">
 
      <v-tabs
      background-color="primary"
      centered
      dark
      icons-and-text
      >
        <v-tabs-slider color="yellow"></v-tabs-slider>

        <v-tab key="userCardTab">
          {{ $t("userCardTitle") }}
        </v-tab>
        <v-tab key="checklistTab">
          {{ $t("checkListQuestions") }}
        </v-tab>
        <v-tab key="contractListTab" v-if="isContractListEnabled">
          {{ $t("contractList") }}
        </v-tab>
        <v-tab key="questionaryResultTab" v-if="isContractListEnabled">
          {{ $t("questionaryResult") }}
        </v-tab>

        <v-tab-item key="userCardTab">
            <user-card
                ref="userCard"
                pageType="VideoConversation"
                :expansionPanel="true"
                :leadPartyId="leadPartyId"
                :tckn="tckn"
                @setNfcStatusUserCard="sendNfcStatus"
            />
        </v-tab-item>

        <v-tab-item key="checklistTab">
          <check-list  
           :checkListItems = "checkListItems"
           :selected = "selected"
          />
        </v-tab-item>

        <v-tab-item key="contractListTab">
          <basic-list  
           :basicListItems = "contractInfoList"
          />
        </v-tab-item>

        <v-tab-item key="questionaryResultTab">
          <questionary-result 
           :processVariablesList = "processVariablesList" 
          />
        </v-tab-item>

      </v-tabs>
    </v-card-text>
  </v-card>
</template>

<script>
import UserCard  from "./UserCard";
import CheckList  from "./CheckList";
import BasicList  from "./BasicList";
import QuestionaryResult from './QuestionaryResult';

export default {
  name: "tab-holder",
  components: {UserCard,CheckList,BasicList,QuestionaryResult},
  data () {
    return {
  
    tab: null,
    text: 'Lorem ipsum',

    }
  },
  props: {
    checkListItems: {
      type: Array,
      default: () => []
    },
    leadPartyId: {
      type: Number,
      required: true
    },
    tckn: {
      type: String,
      required: true
    },
    processId: {
      type: String,
      default: () => null,
      required: false
    },
    selected: {
      type: Array,
      default: () => []
    },
    isContractListEnabled: {
      type: String,
      default: () => false,
      required: false
    },
    contractInfoList: {
      type: String,
      default: () => "",
      required: false
    },
    processVariablesList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getUserImageData(){
      return this.$refs.userCard.getImageData();
    },
    sendNfcStatus(status) {
      console.log("===TABHOLDERNFCSTATUS===", status);
      this.$emit("setNfcStatus", status);
    }
  }
    
};
</script>



// WEBPACK FOOTER //
// src/components/TabHolder.vue